import React from 'react';
import { Field } from 'bloomer/lib/elements/Form/Field/Field';
import { Label } from 'bloomer/lib/elements/Form/Label';
import { Control } from 'bloomer/lib/elements/Form/Control';
import { Radio } from 'bloomer/lib/elements/Form/Radio';
import Spacer from './Spacer';
import Conditional from '../components/Conditional';
import { Help } from 'bloomer/lib/elements/Form/Help';
import styled from 'styled-components';

const ErrorableField = ({
  hasError,
  children,
}: {
  hasError: boolean;
  children:
    | React.ReactChildren
    | Element
    | (Element | Element[])[]
    | (JSX.Element | JSX.Element[])[];
}) => {
  const El = styled(Field)`
    border: ${hasError ? '1px solid #ff3860;' : 'none'};
  `;
  return <El>{children}</El>;
};

interface PropTypes {
  label: string;
  name: string;
  value: string;
  radioButtons: string[];
  required: boolean;
  handleChange: (event: React.FormEvent<HTMLElement>) => void;
  errRef?: React.RefObject<any>;
  error?: string;
}

const RadioButtonFieldSet = ({
  label,
  name,
  value,
  handleChange,
  required,
  radioButtons,
  errRef,
  error,
}: PropTypes) => {
  const ref = name === error ? errRef : null;
  return (
    <ErrorableField hasError={ref !== null}>
      <span ref={ref} aria-hidden="true" />
      <Label>{label}</Label>
      {radioButtons.map(radio => (
        <Control key={`control-radio-${radio}`}>
          <Radio
            name={name}
            value={radio}
            checked={value === radio}
            onChange={handleChange}
            required={required}
          >
            <Spacer className="is-capitalized">{radio}</Spacer>
          </Radio>
        </Control>
      ))}
      <Conditional check={ref !== null}>
        <Help isColor="danger">Please fill out this field</Help>
      </Conditional>
    </ErrorableField>
  );
};

export default RadioButtonFieldSet;
